import { useAppStore } from '@/stores/app'

export function useGlobalDialog() {
  const setState = variable => {
    const appStore = useAppStore()
    if (variable == true) {
      appStore.setDialogActive()
    } else {
      appStore.setDialogInactive()
    }
  }

  return {
    setState
  }
}
